export default __webpack_public_path__ + "static/media/MotionCoinsStore.d4b8e03c.png";